import { toTodo, Task } from 'owa-todo-service';
import type { TodoDescriptor } from '../index';
import { getSubtodoCompareForDescriptor } from './getCompareForDescriptor';
import type { Todo } from 'owa-todo-types';

export function toTodos(descriptor: TodoDescriptor, tasks: Task[]): Todo[] {
    const todos = tasks.map(toTodo);
    // sort subtasks based off of the descriptor
    const compareFunc = getSubtodoCompareForDescriptor(descriptor);
    compareFunc && todos.forEach(task => task.Subtasks?.sort(compareFunc));
    return todos;
}
